import React from 'react';
import styles from '../styles/skills.scss';
import {IconTextContainer} from "./portfolio/IconTextContainer";
import {Docker} from "./svg/tech_icons/Docker";
import {Kafka} from "./svg/tech_icons/Kafka";
import {RabbitMQ} from "./svg/tech_icons/RabbitMQ";
import {FastAPI} from "./svg/tech_icons/FastAPI";
import {DynamoDB} from "./svg/tech_icons/DynamoDB";
import {ELB} from "./svg/tech_icons/aws/ELB";
import {NLB} from "./svg/tech_icons/aws/NLB";
import {S3} from "./svg/tech_icons/S3";
import {AwsApiGateway} from "./svg/tech_icons/AwsApiGateway";
import {Lambda} from "./svg/tech_icons/aws/Lambda";
import {CloudFront} from "./svg/tech_icons/CloudFront";
import {VPC} from "./svg/tech_icons/aws/VPC";
import {SQS} from "./svg/tech_icons/aws/SQS";
import {SNS} from "./svg/tech_icons/aws/SNS";
import {IAM} from "./svg/tech_icons/aws/IAM";
import {ECS} from "./svg/tech_icons/aws/ECS";
import {EC2} from "./svg/tech_icons/aws/EC2";
import {Cognito} from "./svg/tech_icons/aws/Cognito";
import {Cloudformation} from "./svg/tech_icons/aws/Cloudformation";
import {Athena} from "./svg/tech_icons/aws/Athena";
import {Python} from "./svg/tech_icons/Python";
import {Javascript} from "./svg/tech_icons/Javascript";
import {Php} from "./svg/tech_icons/Php";
import {Ansible} from "./svg/tech_icons/Ansible";
import {Terraform} from "./svg/tech_icons/Terraform";
import {Faust} from "./svg/tech_icons/Faust";
import {RocksDB} from "./svg/tech_icons/RocksDB";
import {Spark} from "./svg/tech_icons/Spark";
import {ReactIcon} from "./svg/tech_icons/ReactIcon";
import {Redux} from "./svg/tech_icons/Redux";
import {Mobx} from "./svg/tech_icons/Mobx";
import {D3JS} from "./svg/tech_icons/D3JS";
import {Webpack} from "./svg/tech_icons/Webpack";


export const Skills = props => {
    return (
        <div className={styles.container}>
            <span className={styles.sectionContainer}>
                <span className={styles.title}>Cloud</span>
                <hr className={styles.line}/>
                <span className={styles.skillsContainer}>
                    <IconTextContainer
                        text={'VPC'}
                        IconComp={VPC}
                        key={'bio-vpc-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Elastic Load Balancer'}
                        IconComp={ELB}
                        key={'bio-elb'}
                        extraStyle={styles.bioTechIcon}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Network Load Balancer'}
                        IconComp={NLB}
                        key={'bio-nlb'}
                        extraStyle={styles.bioTechIcon}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'S3'}
                        IconComp={S3}
                        key={'bio-s3'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'API Gateway'}
                        IconComp={AwsApiGateway}
                        key={'bio-apigateway-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Lambda'}
                        IconComp={Lambda}
                        key={'bio-awslambda-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer text={'DynamoDB'} IconComp={DynamoDB} key={'bio-ddb-icon'}/>
                    <IconTextContainer
                        text={'SQS'}
                        IconComp={SQS}
                        key={'bio-SQS-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'SNS'}
                        IconComp={SNS}
                        key={'bio-SNS-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'IAM'}
                        IconComp={IAM}
                        key={'bio-IAM-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'ECS'}
                        IconComp={ECS}
                        key={'bio-ECS-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'EC2'}
                        IconComp={EC2}
                        key={'bio-EC2-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Cognito'}
                        IconComp={Cognito}
                        key={'bio-Cognito-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Cloudfront Distribution'}
                        IconComp={CloudFront}
                        key={'bio-cloudfront-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Cloudformation'}
                        IconComp={Cloudformation}
                        key={'bio-Cloudformation-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Athena'}
                        IconComp={Athena}
                        key={'bio-Athena-icon'}
                        // onClick={() => {window.open('', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Ansible'}
                        IconComp={Ansible}
                        key={'bio-Javascript'}
                    />
                    <IconTextContainer
                        text={'Terraform'}
                        IconComp={Terraform}
                        key={'bio-Terraform'}
                    />
                    <IconTextContainer
                        text={'Troposphere'}
                        IconComp={Python}
                        key={'bio-Terraform'}
                    />
                </span>
            </span>


            <span className={styles.sectionContainer}>
                <span className={styles.title}>Backend</span>
                <hr className={styles.line}/>
                <span className={styles.skillsContainer}>
                    <IconTextContainer text={'Docker'} IconComp={Docker} key={'bio-docker'}/>
                    <IconTextContainer text={'Kafka'} IconComp={Kafka} key={'bio-kafka-icon'}/>
                    <IconTextContainer text={'RabbitMQ'} IconComp={RabbitMQ} key={'bio-kafka-icon'}/>
                    <IconTextContainer text={'FastAPI'} IconComp={FastAPI} key={'bio-fastapi-icon'}/>
                    <IconTextContainer text={'DynamoDB'} IconComp={DynamoDB} key={'bio-ddb-icon'}/>
                </span>
            </span>


            <span className={styles.sectionContainer}>
                <span className={styles.title}>Frontend</span>
                <hr className={styles.line}/>
                <span className={styles.skillsContainer}>
                    <IconTextContainer
                        text={'ReactJS'}
                        IconComp={ReactIcon}
                        key={'bio-react'}
                        onClick={() => {window.open('https://reactjs.org/', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Webpack'}
                        IconComp={Webpack}
                        key={'bio-webpack'}
                        extraStyle={styles.bioTechIcon}
                        onClick={() => {window.open('https://webpack.js.org/', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Redux'}
                        IconComp={Redux}
                        key={'bio-Redux'}
                        onClick={() => {window.open('https://redux.js.org/', '_blank');}}
                    />
                    <IconTextContainer
                        text={'Mobx'}
                        IconComp={Mobx}
                        key={'bio-Mobx'}
                        extraStyle={styles.bioTechIcon}
                        onClick={() => {window.open('https://mobx.js.org/', '_blank');}}
                    />
                    <IconTextContainer
                        text={'D3JS'}
                        IconComp={D3JS}
                        key={'bio-d3js'}
                        extraStyle={styles.bioTechIcon}
                        onClick={() => {window.open('https://d3js.org/', '_blank');}}
                    />
                </span>
            </span>

            <span className={styles.sectionContainer}>
                <span className={styles.title}>Stream Processing</span>
                <hr className={styles.line}/>
                <span className={styles.skillsContainer}>
                    <IconTextContainer text={'Faust'} IconComp={Faust} key={'dist-counter-faust-icon'}/>
                    <IconTextContainer text={'Kafka'} IconComp={Kafka} key={'dist-counter-kafka-icon'}/>
                    <IconTextContainer text={'RocksDB'} IconComp={RocksDB} key={'dist-counter-RocksDB-icon'}/>
                    <IconTextContainer
                        text={'ApacheSpark'}
                        IconComp={Spark}
                        key={'bio-Spark'}
                        extraStyle={styles.bioTechIcon}
                        onClick={() => {window.open('https://spark.apache.org/', '_blank');}}
                    />
                </span>
            </span>

            <span className={styles.sectionContainer}>
                <span className={styles.title}>Languages</span>
                <hr className={styles.line}/>
                <span className={styles.skillsContainer}>
                     <IconTextContainer
                         text={'Python'}
                         IconComp={Python}
                         key={'bio-py'}
                     />
                    <IconTextContainer
                        text={'Javascript'}
                        IconComp={Javascript}
                        key={'bio-Javascript'}
                    />
                    <IconTextContainer
                        text={'PHP'}
                        IconComp={Php}
                        key={'bio-php'}
                    />
                </span>
            </span>
        </div>
    )
};
